import Vue from 'vue'

var channelId = 'UCIE_BvU71U28q6It6F6dl0g,UC3GZtOeb7Pe2HVYYPk6ilnA'
var key = 'AIzaSyDBzj0pxOrn64NBkWOVKI0l6c5afobDfP0'
var maxResults = 3
var part = 'snippet,contentDetails'

export default {
  getPlaylist (playlist) {
    var url = 'https://www.googleapis.com/youtube/v3/playlistItems?playlistId=' + playlist + '&key=' + key + '&maxResults=' + maxResults + '&part=' + part
    var p1 = new Promise(function (resolve, reject) {
      Vue.http.get(url).then(response => {
        resolve(response)
      }, response => {
        // error goes here
        reject(response)
      })
    })
    return p1
  },
  getVideos (channel) {
    var url = 'https://www.googleapis.com/youtube/v3/search?order=date&key=' + key + '&channelId=' + channel + '&maxResults=' + maxResults + '&part=snippet,id'
    var p1 = new Promise(function (resolve, reject) {
      Vue.http.get(url).then(response => {
        resolve(response)
      }, response => {
        // error goes here
        reject(response)
      })
    })
    return p1
  },
  getSubscribers () {
    var url = 'https://www.googleapis.com/youtube/v3/channels?part=statistics&id=' + channelId + '&key=' + key
    var p1 = new Promise(function (resolve, reject) {
      Vue.http.get(url).then(response => {
        resolve(response)
      }, response => {
        // error goes here
        reject(response)
      })
    })
    return p1
  }
}



// WEBPACK FOOTER //
// ./src/gateways/youtube.js